import { render, staticRenderFns } from "./xqqx.vue?vue&type=template&id=9a9c8aa6"
import script from "./xqqx.vue?vue&type=script&lang=js"
export * from "./xqqx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports